import { apiFetch } from "@/lib/api";

export interface BenchMachineSummary {
  machineId: string;
  engineVersion: string | null;
  capabilitiesUrl: string | null;
  apiBaseUrl: string | null;
  hostname: string | null;
  lastSeenAt: string;
  registeredAt: string;
  online: boolean;
}

export async function fetchBenchMachines(): Promise<BenchMachineSummary[]> {
  const payload = await apiFetch<{ benches: BenchMachineSummary[] }>("/api/benches");
  return Array.isArray(payload.benches) ? payload.benches : [];
}

export async function fetchBenchMachine(machineId: string): Promise<BenchMachineSummary | null> {
  const trimmed = String(machineId ?? "").trim();
  if (!trimmed) {
    return null;
  }
  try {
    const payload = await apiFetch<{ bench: BenchMachineSummary }>(`/api/benches/${encodeURIComponent(trimmed)}`);
    return payload.bench ?? null;
  } catch {
    return null;
  }
}
